import { Component, Style } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import { CompInfo, NativeExtensions } from '@wix/thunderbolt-components-native'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'
import { mapValues } from '../../utils/mapValues'
import { Css } from '../../shared.types'
import { mapValuesValues } from '../../utils/mapValuesValues'
import { NodeRefs } from '@wix/thunderbolt-catharsis'

export const compCssMappers = ({ extensions }: NativeExtensions) => {
	const carmiData = undefined as never
	return createCssCompNode('compCssMappers', 'compCssMappers', {
		getDependencies: (component: Component, refs) => {
			const extension = extensions[component.componentType]
			if (!extension) {
				return null
			}

			return mapValues(extension.deps, (__, dep) => {
				if (dep === 'styleProperties') {
					return refs.compStyles(component)
				} else if (dep === 'uiType') {
					return refs.uiType(component)
				}

				if (!compInfoNodes[dep]) {
					console.warn(`compCssMappers: missing compInfoNode for ${dep}`)
				}

				return compInfoNodes[dep].getDependencies(component, refs as NodeRefs<any>)
			})
		},
		toViewItem: (component, deps) => {
			const extension = extensions[component.componentType]
			if (!deps || !extension) {
				return null
			}

			const compInfo = mapValues(extension.deps, (__, dep) => {
				if (dep === 'styleProperties' || dep === 'uiType') {
					return deps[dep]
				}

				return compInfoNodes[dep].toViewItem(component, deps[dep] as never)
			}) as CompInfo

			const styleProperties = (compInfo.styleProperties as any) as Css<Style>
			if (styleProperties) {
				if (styleProperties.type === 'classic') {
					return {
						type: 'classic' as const,
						css: mapValues(styleProperties.css, (style: Style) =>
							extension.resolver({ ...compInfo, styleProperties: style.style.properties }, carmiData)
						),
					}
				}

				return {
					type: 'variants' as const,
					css: mapValuesValues(styleProperties.css, (style: Style) =>
						extension.resolver({ ...compInfo, styleProperties: style.style.properties }, carmiData)
					),
				}
			}

			return {
				type: 'classic' as const,
				css: {
					'': extension.resolver(compInfo, carmiData),
				},
			}
		},
	})
}
